import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class WordpressService {
  public host: String;

  constructor(private http: Http) {
    this.host = 'http://opinemostodos.com.ar/nonvisible-wordpress/index.php';
   }

  getSurveys(): Observable<any> {
    return this.http.get( this.host + '/wp-json/wp/v2/survey');
  }

  getSurveysByID(id: string): Observable<any> {
    return this.http.get( this.host + '/wp-json/wp/v2/survey/' + id);
  }

  getCategories(): Observable<any> {
    return this.http.get( this.host + '/wp-json/wp/v2/categories');
  }

  getTags(): Observable<any> {
    return this.http.get( this.host + '/wp-json/wp/v2/tags');
  }

  getCategoriesByID(id: string): Observable<any> {
    return this.http.get( this.host + '/wp-json/wp/v2/categories/' + id);
  }

  getIdCategories(categories: any, category: string) {
    const returnValue = categories.filter( categs => categs.slug === category );

    return returnValue[0] ? returnValue[0].id : null ;

  }


  getIdCategoriEncuesta(categories: any) {
    const encId = 'encuestas';

    const returnValue = categories.filter( categs => categs.slug === 'encuesta' );
    return returnValue[0] ? returnValue[0].id : null ;

  }



  getImageFromRender(text: string): string {
    const toStr = text ? text.indexOf('/>') : 0;
    const fromStr = text ? text.indexOf('<img') : 0;
    return text ? `${text.substr(fromStr, toStr - 1)}` : '';
  }

  getSrcImageFromRender(text: string): string {
    const fromStr = text ? text.indexOf('src="') : 0;
    const toStr = text ? text.indexOf('" a', fromStr) : 0;
    return text ? `${text.substr(fromStr + 5, toStr - fromStr - 5 )}` : '';
  }

  // Trae el primer texto obviando la primera imagen en caso que haya
  getShortText(text: string, length: number): string {
    let toStr = text ? text.indexOf('img/>') : 0;
    const sum = toStr >= 0 ? 2 : 0;
    toStr = toStr >= 0 ? toStr : 0;
    return text ? `${text.substr(toStr + sum , toStr + length )}` : '';
  }
  testEmail(payload) {
     this.http.post('http://dev.opinemostodos.com.ar/contact.php', {
      name: payload.name,
      email: payload.email,
      phone: payload.phone,
      company: payload.company,
      country: payload.country,
      city: payload.city,
      message: payload.message,
    }).subscribe(
        res => {
          console.log(res);
        },
        err => {
          console.log("Error occured");
        }
      );


  }

}



// WEBPACK FOOTER //
// C:/Users/gdb/Documents/work/garrido-angular/garrido-front/src/app/services/wordpress.service.ts